var _rect, _rect2, _g, _g2, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectCardIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 105,
    viewBox: "0 0 124 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.35794,
    y: 26.086,
    width: 121.924,
    height: 78.4045,
    rx: 4.58592,
    fill: "url(#paint0_radial_296_665)",
    stroke: "url(#paint1_linear_296_665)",
    strokeWidth: 1.01909
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.21,
    x: 28.3665,
    y: 10.3325,
    width: 69.3221,
    height: 65.7671,
    rx: 5.09547,
    fill: "#00FD8E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21,
    filter: "url(#filter0_f_296_665)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.0339,
    y: 5,
    width: 79.987,
    height: 76.432,
    rx: 5.09547,
    fill: "#00FD8E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_296_665)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.6992,
    y: 15.6648,
    width: 60.4346,
    height: 55.1021,
    rx: 5.09547,
    fill: "url(#paint2_linear_296_665)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6256 38.7706C75.6872 37.8321 74.5279 37.1144 73.2582 36.6728C73.0926 32.3116 71.8229 28.0609 69.5043 24.307C69.3387 23.9206 66.468 20.0562 65.0327 18.6209C64.4807 18.1241 63.5974 18.1241 63.0453 18.6209C57.8561 23.8653 55.0407 29.993 54.8199 36.6728C53.5502 37.1144 52.3909 37.8321 51.4524 38.7706C47.9745 41.9724 47.6985 47.3825 50.9004 50.9155C51.1212 51.1916 51.4524 51.3572 51.8388 51.3572H51.894C52.2253 51.3572 52.6117 51.2468 52.8325 50.9707L56.5864 47.5481C57.3593 49.5354 58.2978 51.4676 59.5123 53.2341C60.6163 54.8903 63.4318 55.0559 64.2598 55.0559H64.315C65.4743 55.0559 67.4617 54.8351 68.4002 53.5101C69.6699 51.6884 70.7188 49.6458 71.4916 47.5481L75.2455 50.9707C75.4664 51.2468 75.8528 51.3572 76.184 51.3572H76.2392C76.6256 51.3572 76.9569 51.1916 77.1777 50.9155C80.3796 47.3825 80.1035 41.9724 76.6256 38.7706ZM64.039 39.5986C61.4444 39.5434 59.3466 37.4456 59.3466 34.851C59.3466 32.2564 61.4444 30.1587 64.039 30.1587C66.6336 30.1587 68.7314 32.2564 68.7314 34.851C68.7314 37.4456 66.6336 39.5434 64.039 39.5986Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4194 57.0432H62.6592V63.5021H65.4194V57.0432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.946 55.9944H67.1858V61.9013H69.946V55.9944Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8925 55.9944H58.1323V61.4044H60.8925V55.9944Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_296_665",
    x: 18.9576,
    y: 0.923625,
    width: 88.1398,
    height: 84.5849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.03819,
    result: "effect1_foregroundBlur_296_665"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_296_665",
    x: 19.4319,
    y: 1.39748,
    width: 88.9692,
    height: 83.6367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.13366,
    result: "effect1_foregroundBlur_296_665"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_296_665",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-86.1789 -50.9813) rotate(25.2724) scale(587.36 2195.09)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259615,
    stopColor: "#040209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FD8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_296_665",
    x1: -19.1817,
    y1: -17.5057,
    x2: -3.56211,
    y2: 112.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFDA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_296_665",
    x1: 4.68674,
    y1: -1.68625,
    x2: 62.8363,
    y2: 71.6238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FD8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009755"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectCardIcon1);
export default __webpack_public_path__ + "static/media/RectCardIcon1.e5c96f4068d52fa10263921b6ec613fe.svg";
export { ForwardRef as ReactComponent };